/* eslint-disable react-hooks/exhaustive-deps */
import { FC, memo, useCallback} from 'react'
import { useTranslation } from 'react-i18next'

import { FaTrashAlt } from 'react-icons/fa'

import {
  Button,
  Tooltip,
} from '@mui/material'

import { IColumn } from 'types'
import { usePUT_removeStudentFromTeamMutation } from 'redux/api/teamsApi'
import { actionIcon, trashIcon } from 'utils/customizedTheme'

export const useTableModel = () => {

  const { t } = useTranslation()

  const handleGenderFormat = useCallback(
    (cellValue: string) => (cellValue ? t(`common.${cellValue.toLowerCase()}`) : ''),
    [],
  )

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <Actions row={row} index={index} /> ,
    [],
  )

  const columns: IColumn[] = [
    {
      title: `${t('common.academic-id')}`,
      field: 'academic_id',
      order: true,
      width: '25%',
    },
    {
      title: `${t('common.name')}`,
      field: 'full_name',
      fieldAlias: 'first_name',
      order: true,
      width: '25%',
    },
    {
      title: `${t('common.email')}`,
      field: 'email',
      order: true,
      width: '25%',
    },
    {
      title: `${t('common.gender')}`,
      field: 'gender',
      width: '20%',
      order: true,
      format: handleGenderFormat,
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}

interface IProps {
  row: any
  index: number
}

const Actions: FC<IProps> = memo(({ row }) => {
  const { t } = useTranslation()
  const [unenrollStudent] = usePUT_removeStudentFromTeamMutation()
  
  return (
    <>
      {row.actions?.is_deletable && (   
        <Tooltip title={`${t('common.unenroll')}`} arrow placement='top'>
          <Button
            onClick={() => unenrollStudent({id: row.team_id, student_id: row.student_profile_id})}
            variant='outlined'
            color='error'
            disableElevation
            sx={{
              ...actionIcon, ...trashIcon
            }}
          > 
            <FaTrashAlt/>
          </Button>
        </Tooltip>
      )}
    </>
  )
})
